import { useMutation } from '@tanstack/react-query'

import { createPrepaymentInvoice } from '../services'
import { CryptoInvoiceMutationKeys } from '../../keys'

import type { CreatePrepaymentInvoiceRequest } from '../../type'

export default function useMutationCreatePrepayment() {
	return useMutation({
		mutationKey: [CryptoInvoiceMutationKeys.CreatePrepayment],
		mutationFn: (payload: CreatePrepaymentInvoiceRequest) =>
			createPrepaymentInvoice(payload),
	})
}
